import { createReducer, on } from '@ngrx/store';
import * as pageActions from '../actions/themes.action';
import * as utility from '../../../utility';
import { Theme } from '../../models';

export interface ThemesState {
  entities: { [id: number]: Theme };
  loaded: boolean;
  loading: boolean;
  error?: any;
}

export const initialState: ThemesState = {
  entities: {},
  loaded: false,
  loading: false,
};

export const ThemeReducer = createReducer(
  initialState,
  on(pageActions.LoadThemes, (state: ThemesState) => {
    return {
      ...state,
      loading: true,
      loaded: false,
    };
  }),
  on(pageActions.LoadThemesSuccess, (state: ThemesState, { themes }) => {
    const entities = utility.ToEntities(themes, 'id', state.entities);
    return {
      ...state,
      entities,
      loading: false,
      loaded: true,
    };
  }),
  on(pageActions.LoadThemesFail, (state: ThemesState, { error }) => {
    return {
      ...state,
      loading: false,
      loaded: false,
      error,
    };
  })
);

export const getThemesEntities = (state: ThemesState) => state.entities;
export const getThemesLoading = (state: ThemesState) => state.loading;
export const getThemesLoaded = (state: ThemesState) => state.loaded;
